(() => {
class $5b5a46e20f05ce20$var$PromoBlock extends HTMLElement {
    constructor(){
        super();
    }
    connectedCallback() {
        this.desktopHeightPixelsIfFullWidth = this.getAttribute('data-desktop-height-pixels-if-full-width');
        this.grid = document.querySelector('ul.product-grid');
        this.promoMediaMobile = this.querySelector('.promo-media-mobile');
        this.promoMediaDesktop = this.querySelector('.promo-media-desktop');
        this.desktopWidthGrid = this.parentElement.getAttribute('data-desktop-width-grid');
        this.hasVideoOnMobile = this.hasAttribute('data-has-video-on-mobile');
        this.hasVideoOnDesktop = this.hasAttribute('data-has-video-on-desktop');
        this.startDate = this.getAttribute('data-start-date');
        this.endDate = this.getAttribute('data-end-date');
        this.href = this.getAttribute('data-href');
        this.handleMobileHeightPixels();
        document.addEventListener('product-grid-view-changed', ()=>{
            this.handleMobileHeightPixels();
        });
        this.observeGrid();
        this.addClickHandler();
        this.handleDate();
    }
    handleDate() {
        if (!this.startDate || !this.endDate) {
            this.parentElement.classList.remove('d-none');
            return;
        }
        const startDate = new Date(this.startDate);
        const endDate = new Date(this.endDate);
        const today = new Date();
        if (today >= startDate && today <= endDate) this.parentElement.classList.remove('d-none');
    }
    addClickHandler() {
        if (!this.href) return;
        this.addEventListener('click', ()=>{
            window.location.href = this.href;
        });
    }
    handleMobileHeightPixels() {
        const productGrid = document.querySelector('ul.product-grid');
        const productGridView = productGrid?.getAttribute('product-grid-view');
        const largeProductCardSizeMobile = productGrid?.getAttribute('data-large-product-card-size-mobile');
        const mobileHeightPixelsIfFullWidth = this.getAttribute('data-mobile-height-pixels-if-full-width');
        if (!productGridView || !mobileHeightPixelsIfFullWidth || !this.promoMediaMobile) return;
        let isPromoBlockFullWidth = false;
        if (productGridView === 'mobile-single' || productGridView === 'default' && this.parentElement?.classList.contains('mobile-width-grid-2') || largeProductCardSizeMobile == 'large') isPromoBlockFullWidth = true;
        if (isPromoBlockFullWidth && window.innerWidth < 750) this.style.height = `${mobileHeightPixelsIfFullWidth}px`;
        else this.style.height = '100%';
    }
    observeGrid() {
        if (!this.grid) return;
        const observer = new ResizeObserver((mutations)=>{
            mutations.forEach((mutation)=>{
                // Adjust the height of promo block if it takes full width on desktop
                if (window.innerWidth >= 750) {
                    const columnsInGrid = window.getComputedStyle(mutation.target)?.gridTemplateColumns?.split(' ')?.length;
                    let desktopWidthGridNumber = null;
                    if (this.desktopWidthGrid) desktopWidthGridNumber = Number(this.desktopWidthGrid);
                    if (desktopWidthGridNumber && desktopWidthGridNumber >= columnsInGrid) {
                        this.style.height = `${this.desktopHeightPixelsIfFullWidth}px`;
                        this.promoMediaDesktop.style.height = this.hasVideoOnDesktop ? '100%' : 'auto';
                    } else {
                        this.style.height = '100%';
                        this.promoMediaDesktop.style.height = '100%';
                    }
                }
            });
        });
        observer.observe(this.grid, {
            attributes: true
        });
    }
}
if (!customElements.get('promo-block')) customElements.define('promo-block', $5b5a46e20f05ce20$var$PromoBlock);


class $7b84ccb79eb6d88b$var$FilteredProductList extends HTMLElement {
    constructor(){
        super();
        this.observer = null;
        this.hasLoaded = false;
    }
    connectedCallback() {
        this.sectionId = this.getAttribute('section-id');
        this.collectionUrl = this.getAttribute('collection-url');
        this.parameters = new URLSearchParams();
        this.productId = this.getAttribute('product-id');
        this.rteFormatter = this.querySelector('rte-formatter');
        this.minimumVisible = Number(this.getAttribute('minimum-visible')) || 0;
        this.maximumVisible = Number(this.getAttribute('maximum-visible')) || 20;
        if (Number.isNaN(this.minimumVisible)) this.minimumVisible = 0;
        const filterParameters = this.getAttribute('filters')?.split(',') ?? [];
        for (const param of filterParameters){
            const [key, value] = param.split('=');
            if (!key || !value) continue;
            this.parameters.append(key, value);
        }
        this.parameters.set('section_id', this.sectionId);
        this.parameters.set('filter.v.availability', 1);
        if (filterParameters.length > 0) this.setupObserver();
    }
    setupObserver() {
        const options = {
            root: null,
            rootMargin: '20% 0px',
            threshold: 0
        };
        this.observer = new IntersectionObserver((entries)=>{
            entries.forEach((entry)=>{
                if (entry.isIntersecting && !this.hasLoaded) {
                    this.hasLoaded = true;
                    this.loadContent();
                    this.observer.disconnect();
                }
            });
        }, options);
        this.observer.observe(this);
    }
    async loadContent() {
        try {
            const url = `${this.collectionUrl}?${this.parameters.toString()}`;
            const response = await fetch(url);
            if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
            const html = await response.text();
            const shopifySection = this.closest('.shopify-section');
            const clone = document.createElement('div');
            clone.innerHTML = html;
            const productItems = new Map([
                ...clone.querySelectorAll(`product-card`)
            ].map((e)=>[
                    e.dataset.productId,
                    e
                ]));
            const viewAllButton = clone.querySelector('[class*="product_list_button"]');
            const rteFormatter = clone.querySelector('rte-formatter');
            for(let i = 0; i < productItems.size; i++){
                const [id, product] = [
                    ...productItems.entries()
                ][i];
                const removeItem = id === this.productId || i === productItems.size - 1 && !productItems.has(this.productId) && productItems.size > this.maximumVisible;
                if (removeItem) {
                    const parent = product.closest('.resource-list__slide') ?? product.closest('.resource-list__item');
                    parent.remove();
                    productItems.delete(id);
                }
            }
            if (viewAllButton) {
                this.parameters.delete('section_id');
                viewAllButton.href = [
                    this.collectionUrl,
                    this.parameters.toString()
                ].join('?');
            }
            if (this.rteFormatter && rteFormatter) rteFormatter.outerHTML = this.rteFormatter.outerHTML;
            if (shopifySection) shopifySection.outerHTML = productItems.size >= this.minimumVisible ? clone.innerHTML : '';
        } catch (error) {
            console.error('Failed to load filtered products:', error);
        }
    }
    disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
    }
}
if (!customElements.get('filtered-product-list')) customElements.define('filtered-product-list', $7b84ccb79eb6d88b$var$FilteredProductList);



})();
//# sourceMappingURL=parcel_scripts.js.map
